
export const OTR_LOCATIONS = {
    FARM: "farm",
    FACTORY: "factory"
}